import { z } from 'zod';

export const emailSchema = z.string().trim().email('Invalid email').max(255);

// Matches the production Supabase Auth minimum password length (8 characters,
// set 2026-08-23). Keep in sync if that server-side setting changes again.
// Shared by signup and password reset -- a newly *set* password should follow
// the same creation policy regardless of which flow set it.
const newPasswordSchema = z.string().min(8, 'Password must be at least 8 characters').max(72);

// Sign-in deliberately does NOT enforce the 8-character minimum: that rule is
// a password-*creation* policy (signup, reset), not a login-time one. A user
// whose existing password predates this policy (or predates any future
// policy change) must still be able to sign in with it -- Supabase never
// retroactively invalidates existing passwords, so client validation must
// not either. Only requires non-empty, matching Supabase's own baseline.
export const signInSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Password is required').max(72),
});

export const signUpSchema = z.object({
  fullName: z.string().trim().min(1, 'Name is required').max(100),
  email: emailSchema,
  password: newPasswordSchema,
});

export const forgotPasswordSchema = z.object({
  email: emailSchema,
});

export const resetPasswordSchema = z
  .object({
    password: newPasswordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });
